import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  selectNewRequestBargiryDate,
  selectNewRequestBargiryTime,
} from "../../redux/newRequest/newRequest.selectors";

import "antd/dist/antd.css";

import { TimePicker } from "antd";
// import TimePicker from "react-time-picker";
// import TimePicker from "react-time-picker/dist/entry.nostyle";

import { toPersianNum } from "../../assets/utils";
import { BargiryTimeInputsStyled } from "./BargiryTimeInputs.styles";
import {
  fetchAuctionAsync,
  setBargiryTime,
  setCalenderBargiryShow,
} from "../../redux/newRequest/newRequest.actions";
import socket from "../../assets/socketConnection";

const BargiryTimeInputs = ({
  selectNewRequestBargiryDate,
  selectNewRequestBargiryTime,

  setCalenderBargiryShow,

  setBargiryTime,

  fetchAuctionAsync,
}) => {
  // useEffect(() => {
  //   document
  //     .querySelectorAll(".ant-picker-time-panel-cell-inner")
  //     .forEach((item) => (item.innerText = toPersianNum(item.innerText)));
  //   // return () => {
  //   //   cleanup
  //   // }
  // }, []);

  // const onSelect = (x) => {
  //   setValue(toPersianNum(x));
  // };

  // const handle_timePicker_change = () => {
  //   // debugger;
  //   document
  //     .querySelectorAll(".ant-picker-time-panel-cell-inner")
  //     .forEach((item) => (item.innerText = toPersianNum(item.innerText)));

  //   document
  //     .querySelector(".ant-picker-input input")
  //     .addEventListener("change", () => alert("hi"));

  //   const xxx = document.querySelector(".ant-picker-input input").value;
  //   // document.querySelector(".ant-picker-input input").value + 1;
  //   const yyy = toPersianNum(xxx);
  //   console.log(toPersianNum(xxx));
  //   document.querySelector(".ant-picker-input input").value = yyy;
  //   debugger;
  //   // console.log(x);
  // };

  const handle_timepicker_change = (time) => {
    setBargiryTime(time);
    fetchAuctionAsync(socket);
  };

  const handle_dateInput_click = () => {
    setCalenderBargiryShow(true);
  };

  return (
    <BargiryTimeInputsStyled className="mt-3 w-100 d-flex align-items-center justify-content-between">
      <div className="flex-basis--50">
        {/* <input
          type="text"
          placeholder="ساعت بارگیری"
          className="input--custom w-100"
          value={
            selectNewRequestBargiryTime &&
            toPersianNum(selectNewRequestBargiryTime.value)
          }
          readOnly
        /> */}
        <TimePicker
          style={{ direction: "ltr" }}
          className="input--custom text-center"
          placeholder="ساعت بارگیری"
          format="HH:mm"
          direction="ltr"
          onChange={(time) => handle_timepicker_change(time)}
          value={selectNewRequestBargiryTime}
          // onSelect={(value) => {
          //   alert("hi");
          //   // setValue(toPersianNum(value));
          // }}
          // onClick={handle_timePicker_change}
          // onChange={(value) => {
          //   console.log(value);
          //   // setTime(value);
          //   setTimeout(() => {
          //     const xxx = document.querySelector(".ant-picker-input input")
          //       .value;
          //     // document.querySelector(".ant-picker-input input").value + 1;
          //     const yyy = toPersianNum(xxx);
          //     console.log(toPersianNum(xxx));
          //     document.querySelector(".ant-picker-input input").value = yyy;
          //     // debugger;
          //   }, 10);

          // setValue(toPersianNum(value));
          // }}
        />
        {/* <TimePicker amPmAriaLabel={true}  disableClock={true} /> */}
      </div>
      <div className="flex-basis--50">
        <input
          type="text"
          placeholder="تاریخ بارگیری"
          className="input--custom w-100 text-center font-size--1"
          value={
            selectNewRequestBargiryDate &&
            toPersianNum(selectNewRequestBargiryDate.value)
          }
          readOnly
          onClick={handle_dateInput_click}
        />
      </div>
    </BargiryTimeInputsStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestBargiryDate: selectNewRequestBargiryDate,
  selectNewRequestBargiryTime: selectNewRequestBargiryTime,
});

const mapDispatchToProps = (dispatch) => ({
  setCalenderBargiryShow: (x) => dispatch(setCalenderBargiryShow(x)),
  setBargiryTime: (x) => dispatch(setBargiryTime(x)),
  fetchAuctionAsync: (x) => dispatch(fetchAuctionAsync(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BargiryTimeInputs);
